export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faire un feedback sur cette analyse"])},
        "textarea_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Décrivez le problème rencontré avec cette analyse…"])},
        "submit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])},
        "success_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre signalement a bien été envoyé."])},
        "error_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur est survenue. Veuillez réessayer."])}
      },
      "en": {
        "report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Report an issue"])},
        "textarea_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Describe the issue with this analysis…"])},
        "submit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])},
        "success_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your report has been submitted successfully."])},
        "error_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred. Please try again."])}
      }
    }
  })
}
